import { defineStore } from "pinia";
import { showError } from "src/utils/notify";

export const useMessages = defineStore("messages", {
  state: () => ({
    msg: [],
    loadmsg: false,
    msgList: [],
    loadmsgList: false,
    selectedGroupDetails: {},
    loadGroupDetails: false,
    loadFriends: false,
    friends: [],
  }),
  getters: {},
  actions: {
    async getChatList(params) {
      try {
        let response = await this.$request.get(
          this.apiEndpoints.MESSAGES(params.page, params.per_page)
        );
        if (params.page == 1) {
          this.loadmsg = false;
        }

        if (response.data) {
          if (params.page == 1) {
            this.msg = [];
          }
          Array.prototype.push.apply(
            this.msg,
            response.data.items ? response.data.items : []
          );
          this.loadmsg = true;
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    resetMessage() {
      this.msg = [];
      this.loadmsg = false;
    },
    resetChatMsg() {
      this.msgList = [];
      this.loadmsgList = false;
    },
    async getChatDetails(id, params) {
      try {
        if (params.page == 1) {
          this.msgList = [];
          this.loadmsgList = false;
        }
        let response = await this.$request.get(
          this.apiEndpoints.CHAT_MESSAGES(id, params.page, params.per_page)
        );
        if (response.data) {
          if (params.page == 1) {
            this.msgList = [];
          }
          Array.prototype.push.apply(
            this.msgList,
            response.data.items ? response.data.items : []
          );
          this.loadmsgList = true;
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async getUnreadMsg(id) {
      try {
        let response = await this.$request.get(
          this.apiEndpoints.CHAT_MESSAGES_UNREAD(id)
        );
        if (response.data) {
          Array.prototype.push.apply(this.msgList, response.data.items);
          this.loadmsgList = true;
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async sendMsg(msgDic, id) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.SEND_MSG(id),
          msgDic
        );
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {}
    },
    async updateNotificationToggle(param, id) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.TOGGLE_NOTIFICATION_MSG(id),
          param
        );
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {}
    },
    async updateGroupName(param, id) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.CHANGE_GROUP_NAME_MSG(id),
          param
        );
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {}
    },
    async getFriendsListForGroup(params) {
      try {
        if (params.page == 1) {
          this.friends = [];
          this.loadFriends = false;
        }
        let data = await this.$request.get(
          this.apiEndpoints.ADD_FRIENDS_GROUP_LIST(params.page, params.per_page)
        );
        if (data.data) {
          Array.prototype.push.apply(
            this.friends,
            data.data.items ? data.data.items : []
          );
          this.loadFriends = true;
        }
        return data.data;
      } catch (error) {}
    },
    async getGroupDetails(id) {
      try {
        this.loadGroupDetails = false;
        this.selectedGroupDetails = {};
        let data = await this.$request.get(
          this.apiEndpoints.GET_GROUP_DETAILS(id)
        );
        if (data.data) {
          this.loadGroupDetails = true;
          this.selectedGroupDetails = data.data.item;
          return data.data;
        } else {
          return { status: false };
        }
      } catch (error) {
        return { status: false };
      }
    },
    async addMemberToGroup(param, id) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.ADD_MEMBER_GROUP(id),
          param
        );
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {}
    },
    async leaveGroup(id) {
      try {
        let data = await this.$request.post(this.apiEndpoints.LEAVE_GROUP(id));
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {}
    },
    async createGroup(param) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.GROUP_CREATE,
          param
        );
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {}
    },
    async findGroup(param) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.FIND_GROUP,
          param
        );
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {}
    },
  },
});
